import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../reducer/CombineReducer";
import { Alert, Button } from "../Common/UI/Index";
import { AlertVariant, ButtonVariantType } from "../Common/UI/Types";
import { ErrorMessageGroup } from "../../ErrorMessages/ErrorMessages";
import { ErrorAlertSlice } from "./Index";
import { AlertType } from "./redux/Types";
import "./Style.scss";

interface IErrorAlertProps {
  showAlert?: boolean;
  closeAlert?: (type: boolean) => void;
  alertTitle?: string;
  errorText?: string[];
  alertType?: string;
  confirmAlert?: () => void;
}

export const ErrorAlert = (props: IErrorAlertProps): JSX.Element => {
  const { showAlert, closeAlert, alertTitle, errorText, alertType } = props;
  const { t: translate } = useTranslation();

  const dispatch = useDispatch();

  const errorAlert = useSelector((state: IRootState) => state.errorAlert);
  const openErrorAlert = showAlert || (errorAlert && errorAlert.openErrorAlert);

  const title = alertTitle || (errorAlert && errorAlert.error.title) || translate("Alert.Title.Default");
  const errorMsg = errorText || (errorAlert && errorAlert.error.message) || [translate("Alert.Message.Default")];
  const type = (alertType && alertType as AlertType) || (errorAlert && errorAlert.error.type) || "error";
  const { actionButtonText, cancelButtonText, buttonVarient, actionClick } = errorAlert?.error;

  const toggleErrorAlert = (): void => {
    dispatch(ErrorAlertSlice.actions.showAlert(false));
    if (closeAlert) {
      closeAlert(false);
    }
  };

  const handleConfirm = (): void => {
    if (actionClick) {
      actionClick();
    } else {
      toggleErrorAlert();
    }
    dispatch(ErrorAlertSlice.actions.showAlert(false));
  };

  const buttons: JSX.Element = (
    <>
      {title !== ErrorMessageGroup["SaveExtractErrMsg"]["E" + "401"].title &&
        <>
          {actionButtonText !== translate("Button.LogoutButton") && cancelButtonText && (
            <Button onClick={toggleErrorAlert} borderless={true}>
              {cancelButtonText ? cancelButtonText : translate("Button.Cancel")}
            </Button>
          )}
          <Button onClick={handleConfirm} variant={buttonVarient ? buttonVarient : ButtonVariantType.FILLED}>
            {actionButtonText ? actionButtonText : translate("Button.Close")}
          </Button>
        </>
      }
    </>
  );

  return (
    <div className="error-alert">
      <Alert
        buttons={buttons}
        title={title}
        type={type || "error"}
        open={openErrorAlert}
        onOpenChange={toggleErrorAlert}
        size={AlertVariant.Medium}
        preventClose={actionButtonText === translate("Button.LogoutButton")}
      >
        {errorMsg.map((msg: string, index: number) => {
          const SecondMessageClass = index === 1 ? "ebt-error-message" : "";
          return (
            <label data-testid="error-alert" key={msg} className={SecondMessageClass}>
              {msg}
            </label>
          );
        })}
      </Alert>
    </div>
  );
};
